// import { useState, useEffect } from 'react';
// import { 
//   signInWithPopup, 
//   signOut, 
//   onAuthStateChanged,
//   signInWithRedirect,
//   getRedirectResult 
// } from 'firebase/auth';
// import { auth, googleProvider } from '../firebase/config';

// export const useAuth = () => {
//   const [user, setUser] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     const unsubscribe = onAuthStateChanged(auth, (user) => {
//       setUser(user);
//       setLoading(false);
//     });

//     // Handle redirect result (for mobile)
//     getRedirectResult(auth)
//       .then((result) => {
//         if (result?.user) {
//           setUser(result.user);
//         }
//       })
//       .catch((error) => {
//         setError(error.message);
//       });

//     return () => unsubscribe();
//   }, []);

//   const signInWithGoogle = async (useRedirect = false) => {
//     try {
//       setError(null);
//       if (useRedirect) {
//         await signInWithRedirect(auth, googleProvider);
//       } else {
//         const result = await signInWithPopup(auth, googleProvider);
//         return result.user;
//       }
//     } catch (error) {
//       setError(error.message);
//       throw error;
//     }
//   };

//   const logout = async () => {
//     try {
//       await signOut(auth);
//     } catch (error) {
//       setError(error.message);
//       throw error;
//     }
//   };

//   return {
//     user,
//     loading,
//     error,
//     signInWithGoogle,
//     logout
//   };
// };

// src/hooks/useAuthRedux.js
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  signInWithGoogle as signInAction,
  logout as logoutAction,
  observeAuthState,
  handleRedirectResult,
  initializeAuthPersistence,
  restoreUserFromStorage,
  clearError,
} from './authSlice';

export const useAuth = () => {
  const dispatch = useDispatch();
  const authState = useSelector((state) => state.auth);

  useEffect(() => {
    // Initialize auth on app start
    const initializeAuth = async () => {
      // Set up persistence
      await dispatch(initializeAuthPersistence('local'));
      
      // Handle any redirect results first
      await dispatch(handleRedirectResult());
      
      // Start observing auth state
      dispatch(observeAuthState());
      
      // Restore user data from storage if available
      dispatch(restoreUserFromStorage());
    };

    initializeAuth();

    // Cleanup on unmount
    return () => {
      if (window.authUnsubscribe) {
        window.authUnsubscribe();
      }
    };
  }, [dispatch]);

  const signInWithGoogle = async (options = {}) => {
    try {
      const result = await dispatch(signInAction(options));
      if (signInAction.fulfilled.match(result)) {
        return result.payload;
      } else {
        throw new Error(result.payload || 'Sign in failed');
      }
    } catch (error) {
      throw error;
    }
  };

  const logout = async () => {
    try {
      const result = await dispatch(logoutAction());
      if (logoutAction.fulfilled.match(result)) {
        return true;
      } else {
        throw new Error(result.payload || 'Logout failed');
      }
    } catch (error) {
      throw error;
    }
  };

  const clearAuthError = () => {
    dispatch(clearError());
  };

  return {
    // State
    user: authState.user,
    isAuthenticated: authState.isAuthenticated,
    loading: authState.loading,
    error: authState.error,
    initialized: authState.initialized,
    
    // User data
    name: authState.name,
    email: authState.email,
    photoURL: authState.photoURL,
    uid: authState.uid,
    phoneNumber: authState.phoneNumber,
    emailVerified: authState.emailVerified,
    accessToken: authState.accessToken,
    
    // Actions
    signInWithGoogle,
    logout,
    clearError: clearAuthError,
  };
};